import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

interface FormFieldProps {
  id: string;
  label: string;
  type?: string;
  value: string | number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  error?: string;
  touched?: boolean;
  placeholder?: string;
  required?: boolean;
  className?: string;
  disabled?: boolean;
}

/**
 * A reusable form field component that works with the useForm hook
 */
export function FormField({
  id,
  label,
  type = "text",
  value,
  onChange,
  onBlur,
  error,
  touched,
  placeholder,
  required = false,
  className,
  disabled = false,
}: FormFieldProps) {
  const showError = touched && error;
  
  return (
    <div className={cn("space-y-2", className)}>
      <div className="flex justify-between">
        <Label 
          htmlFor={id}
          className={cn(
            required && "after:content-['*'] after:ml-0.5 after:text-red-500"
          )}
        >
          {label}
        </Label>
      </div>
      
      <Input
        id={id}
        name={id}
        type={type}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled}
        className={cn(showError && "border-red-500 focus-visible:ring-red-500")}
      />
      
      {showError && (
        <p className="text-sm text-red-500">{error}</p>
      )}
    </div>
  );
}
